<template>
  <v-list-item>
    <v-list-item-avatar color="primary" @click="redirect">
      <v-tooltip bottom :disabled="!canRedirect">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on"
            dark :class="{'can-redirect': canRedirect}">
            mdi-phone-incoming-outline
          </v-icon>
        </template>
        <span>{{ $t('queues.tooltip.redirect') }}</span>
      </v-tooltip>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        <span class="caller-name">{{ call.callerName }}</span> &nbsp;
        <span class="caller-num">&lt;{{ call.callerNum }}&gt;</span>
      </v-list-item-title>
      <v-list-item-subtitle>
        <v-icon small>mdi-timeline-clock</v-icon>
        Position in queue: <span class="position">{{ call.position }}</span>
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        <v-icon small>mdi-timer-sand</v-icon>
        Wait time: <span class="wait-time">{{ wait | formatTime }}</span>
      </v-list-item-subtitle>
    </v-list-item-content>
  <RedirectForm :show="showRedirect" :call="call"
    @cancel="showRedirect=false"/>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex'
import events from 'Store/events'
import RedirectForm from './redirect'

export default {
  name: 'queue-calls',
  data () {
    return {
      showRedirect: false
    }
  },
  props: {
    call: {
      type: Object,
      required: true
    },
    tsNow: {
      type: Number,
      default: 0
    }
  },
  components: { RedirectForm },
  computed: {
    ...mapGetters({
      canRedirectToSelf: 'permissions/canQCallRedirSelf',
      canRedirectToUser: 'permissions/canQCallRedirUser'
    }),
    canRedirect: function () {
      return this.canRedirectToUser || this.canRedirectToSelf
    },
    wait: function () {
      return ~~((this.tsNow - this.call.start) / 1000)
    }
  },
  methods: {
    redirect: function () {
      if (!this.canRedirect) {
        // ignore when no permissions
        return
      }
      if (!this.call) {
        events.pubError('Invalid queue call. Can not redirect!')
        return
      }
      this.showRedirect = true
    }
  }
}
</script>

<style scoped>
.can-redirect {
  cursor: pointer
}
</style>
